import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import {
  TRANSFERT_REASONS
} from '@lba-dev/package.local-globals/ListSAVInters';

import { setDialogContentProp } from '../../actions/dialog';
import store from '../../store';
import CustomTextField from '../CustomInputs/CustomTextField';

const mapStateToProps = ({
  dialog: {
    contentProps: {
      preSav,
      reason,
      comment,
    }
  },
}) => ({
  preSav,
  reason,
  comment,
});

// Raisons de transfert
const REASONS = Object.values(TRANSFERT_REASONS).map(reason => ({
  value: reason,
  label: reason,
}));

class TransformPreSAVDialog extends PureComponent {
  componentDidMount() {
    // Initialiser avec la première raison
    store.dispatch(setDialogContentProp('reason')(REASONS[0].value));
    store.dispatch(setDialogContentProp('comment')(''));
  }

  updateData = (prop, value) => {
    store.dispatch(setDialogContentProp(prop)(value));
  }

  render() {
    const { reason, comment } = this.props;

    return (
      <Grid container spacing={2} style={{ padding: '20px' }}>

        {/* Sélection de la raison */}
        <Grid item xs={12}>
          <FormControl component="fieldset" fullWidth>
            <FormLabel component="legend">
              Raison du transfert *
            </FormLabel>
            <RadioGroup
              value={reason || ''}
              onChange={(e) => this.updateData('reason', e.target.value)}
            >
              {REASONS.map((r) => (
                <FormControlLabel
                  key={r.value}
                  value={r.value}
                  control={<Radio />}
                  label={r.label}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Champ commentaire (obligatoire si "Autres") */}
        {reason === 'Autres' && (
          <Grid item xs={12}>
            <CustomTextField
              label="Précisez la raison *"
              multiline
              rows={4}
              fullWidth
              value={comment || ''}
              path="comment"
              setData={(p, v) => this.updateData(p, v)}
              required
            />
          </Grid>
        )}

        {/* Champ commentaire optionnel pour les autres raisons */}
        {reason && reason !== 'Autres' && (
          <Grid item xs={12}>
            <CustomTextField
              label="Commentaire additionnel (optionnel)"
              multiline
              rows={3}
              fullWidth
              value={comment || ''}
              path="comment"
              setData={(p, v) => this.updateData(p, v)}
            />
          </Grid>
        )}

      </Grid>
    );
  }
}

export default compose(
  connect(mapStateToProps)
)(TransformPreSAVDialog);
